// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_Zqz","cls2":"FocusedNavView-cls2__E_ FocusedNavView-cls1_Zqz","isMobileNav":"FocusedNavView-isMobileNav_fhL"};